enum MuscleFocus {
  Chest = 'Chest',
  Back = 'Back',
  Arms = 'Arms',
  Shoulders = 'Shoulders',
  Legs = 'Legs',
  Glutes = 'Glutes',
  Calves = 'Calves',
  Equally = 'Equally',
}
const muscleFocusQuestion = {
  name: "muscleFocus",
  title: "What muscle group do you want to prioritize",
  description:
    "This helps us create a program that targets your specific goals",
  descriptionLocation: "underTitle",
  type: "radiogroup",
  choices: [
    {
      value: MuscleFocus.Chest,
      text: "Chest",
    },
    {
      value: MuscleFocus.Back,
      text: "Back",
    },
    {
      value: MuscleFocus.Arms,
      text: "Arms",
    },
    {
      value: MuscleFocus.Shoulders,
      text: "Shoulders",
    },
    {
      value: MuscleFocus.Legs,
      text: "Legs",
    },
    {
      value: MuscleFocus.Glutes,
      text: "Glutes",
    },
    {
      value: MuscleFocus.Calves,
      text: "Calves",
    },
    {
      value: MuscleFocus.Equally,
      text: "I want to grow everything equally",
    },
  ],
  isRequired: true,
};

export { MuscleFocus, muscleFocusQuestion };
